import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/Login'
// import PosIndex from '@/view/pos/index'
import Home from '@/view/Home'
   import Welcome from '@/view/Welcome'
   import sourcePayList from '@/view/pay/sourcePayList'
   import posSourceParamsList from '@/view/pay/posSourceParamsList'
   import posSourceParamsAuthList from '@/view/pay/posSourceParamsAuthList'

//
import shopOrderList from '../view/order/orderList'
import shopOrderInfo from '../view/order/orderInfo'
import orderPrint from '../view/order/orderPrint'

// import feeList from '../view/his/feeList'
// import feeForm from '../view/his/feeForm'
// import paymentList from '../view/his/paymentList'
// import paymentForm from '../view/his/paymentForm'
// import receiptList from '../view/his/receiptList'
// import receiptForm from '../view/his/receiptForm'
//
import userRankList from '../view/crm/userRankList'
import rankList from '../view/crm/rankList'
import UserList from '../view/crm/userList'
// import userForm from '../view/crm/userForm'
// import PinList from '../view/appoint/pinList'
// import PinReport from '../view/appoint/pinReport'
// import TravelList from '../view/appoint/travelList'
// import TravelDetail from '../view/appoint/travelDetail'
//
//
   import posMemberList from '../view/pay/posMemberList'
// import posMemberForm from '../view/pay/posMemberForm'
//
   import proxySourceList from '../view/pay/proxySourceList'
//
// import ModuleList from '../view/sys/moduleList'
// import CmpUserList from '../view/sys/cmpUserList'
// import RoleList from '../view/sys/roleList'
// import DepartmentList from '../view/sys/departmentList'
// import EmployeeList from '../view/sys/employeeList'
//
// import employeeForm from '../view/sys/employeeForm'
// import employeeInfo from '../view/sys/employeeInfo'
//
// import hisOrderList from "../view/his/orderList";
   import oilOrderList from "../view/his/oilOrderList";
   import thirdOilOrderList from "../view/his/thirdOilOrderList";
   import thirdOrderList from "../view/his/thirdOrderList";
   import thirdWithdrawList from "../view/car/thirdWithdrawList";
//
//
//
//
// import hisOrderQueueList from "../view/his/orderQueueList";
// import sysLogList from '../view/sys/sysLogList'
// import loginLogList from '../view/sys/loginLogList'
import productList from '../view/his/productList'
// import productForm from '../view/his/productForm'
// import productCategoryList from '../view/his/productCategoryList'
// import feeCategoryList from '../view/his/feeCategoryList'
// import projectList from '../view/engineering/projectList'
// import projectForm from '../view/engineering/projectForm'
// import accountList from '../view/engineering/accountList'
// import preApprovalList from '../view/engineering/preApprovalList'
// import preApprovalForm from '../view/engineering/preApprovalForm'
//
// import contractForm from '../view/engineering/contractForm'
// import projectContractList from '../view/engineering/projectContractList'
// import dailyContractList from '../view/engineering/dailyContractList'
//
// import assetContractList from '../view/engineering/assetContractList'
// import serviceContractList from '../view/engineering/serviceContractList'
// import otherContractList from '../view/engineering/otherContractList'
// import contractLogList from '../view/engineering/contractLogList'
// import contractLogForm from '../view/engineering/contractLogForm'
//
// import contractAmountLogList from '../view/engineering/contractAmountLogList'
//
// import approvalList from '../view/engineering/approvalList'
// import collectReportList from '../view/engineering/collectReportList'
// import agreementList from '../view/engineering/agreementList'
//
// import executeReportList from '../view/engineering/executeReportList'
// import profitReportList from '../view/engineering/profitReportList'
// import projectReportList from '../view/engineering/projectReportList'
// import projectExecutReportList from '../view/engineering/projectExecutReportList'
// import cashReportList from '../view/engineering/cashReportList'
// import departmentReportList from '../view/engineering/departmentReportList'
//
// import budgetList from '../view/engineering/budgetList'
// import profitList from '../view/engineering/profitList'
//
//
// import shopInfo from '../view/shop/shopInfo'
   import shopList from '../view/shop/shopList'
   import shopUserList from '../view/shop/shopUserList'
   import shopRoleList from '../view/shop/sys/shopRoleList'
import shopEmployeeList from '../view/shop/shopEmployeeList'
// import shopEmployeeForm from '../view/shop/sys/shopEmployeeForm'
   import shopForm from '../view/shop/shopForm'
   import shopModuleList from '../view/shop/sys/shopModuleList'
// import shopDepartmentList from '../view/shop/shopDepartmentList'
// import shopCategory from '../view/shop/categoryList'
// import orderTreatList from '../view/order/orderTreatList'
//
//
//
import goodsForm from "../view/mall/goodsForm";
import goodsList from "../view/mall/goodsList";
import goodsCategoryList from "../view/mall/goodsCategoryList";
//
import goodsTypeList from '../view/mall/goodsTypeList'
import goodsAttributeList from '../view/mall/attrList'
//
import proxyList from '../view/proxy/proxyList'
// import proxyGradeList from '../view/proxy/proxyGradeList'
// import proxyForm from '../view/proxy/proxyForm'
// import proxyInfo from '../view/proxy/proxyInfo'
   import yhcList from '../view/pay/yhcList'
   import proxyShopList from '../view/pay/proxyShopList'
//
   import proxyUserList from '../view/proxy/sys/proxyUserList'
   import proxyRoleList from '../view/proxy/sys/proxyRoleList'
   import proxyModuleList from '../view/proxy/sys/proxyModuleList'
   import proxyEmployeeList from '../view/proxy/sys/proxyEmployeeList'
   import proxyDepartmentList from '../view/proxy/sys/proxyDepartmentList'

   import proxyEmployeeForm from '../view/proxy/sys/proxyEmployeeForm'
   import proxyEmployeeInfo from '../view/proxy/sys/proxyEmployeeInfo'
//
   import proxyPosMemberList from '../view/pay/proxyPosMemberList'
   import posMemberTerminalList from '../view/pay/posMemberTerminalList'
   import merchantPayList from '../view/pay/merchantPayList'
   import merchantPayMoreList from '../view/pay/merchantPayMoreList'
//
// import timeTableList from '../view/edu/timeTableList'
// import timetableDetailList from '../view/edu/timetableDetailList'
// import classesList from '../view/edu/classesList'
// import studentSignList from '../view/edu/studentSignList'
// import studentList from '../view/edu/studentList'
// import studentForm from '../view/edu/student/studentForm'
// import studentInfo from '../view/edu/student/studentInfo'
// import schoolList from '../view/edu/schoolList'
// import schoolInfo from '../view/edu/school/schoolInfo'
// import courseList from '../view/edu/courseList'
// import studentConsumeList from '../view/edu/teacher/consumeList'
// import studentEnrollList from '../view/edu/student/enrollList'
// import teacherList from '../view/edu/teacherList'
// import teacherScheduleList from '../view/edu/teacher/scheduleList'
// import dashboard from '../view/edu/dashboard'
// import teacherForm from '../view/edu/teacher/teacherForm'
// import teacherInfo from '../view/edu/teacher/teacherInfo'
// import timetableDetailInfo from '../view/edu/timetableDetailInfo'
// import consultList from '../view/edu/consultList'
// import lsFeeForm from '../view/pay/lsFeeForm'
// import clueList from "../view/edu/clueList";
// import clueLogList from "../view/edu/clueLogList";
//
// import proxyIcbcList from '../view/finance/proxyIcbcList'
// import proxyAccountList from '../view/finance/proxyAccountList'
// import proxyCashList from '../view/finance/proxyCashList'
// import webMenusList from '../view/sys/webMenusList'
// import purchaserList from '../view/wms/purchaserList'
// import purchaserForm from '../view/wms/purchaserForm'
//
//
// //拼车
// import pcFinancePinList from '../view/pinche/finance/financePinList'
// import pcFinanceFeeList from '../view/pinche/finance/financeFeeList'
// import pcFinanceFeeInList from '../view/pinche/finance/financeFeeInList'
// import pcFinanceFeeIn from '../view/pinche/finance/FinanceFeeIn'
// import pcFinanceMileList from '../view/pinche/finance/financeMileList'
   import ownerList from '../view/car/ownerList'
//
// import constructionContractInfo from '../view/engineering/constructionContractInfo'
// import constructionContractList from '../view/engineering/constructionContractList'
// import constructionContractForm from '../view/engineering/constructionContractForm'
//
// import constructionProjectList from "../view/engineering/constructionProjectList";
// import constructionProjectForm from "../view/engineering/constructionProjectForm";
// import constructionPerformanceForm from "../view/engineering/constructionPerformanceForm";
// import constructionPerformanceList from "../view/engineering/constructionPerformanceList";
// import constructionPerformanceInfo from "../view/engineering/constructionPerformanceInfo";
//
// import supervisionContractList from "../view/engineering/supervisionContractList";
// import supervisionContractForm from "../view/engineering/supervisionContractForm";
// import supervisionContractInfo from "../view/engineering/supervisionContractInfo";
//
// import supervisionProjectList from "../view/engineering/supervisionProjectList";
// import supervisionProjectForm from "../view/engineering/supervisionProjectForm";
//
//
// import supervisionPerformanceForm from "../view/engineering/supervisionPerformanceForm";
// import supervisionPerformanceInfo from "../view/engineering/supervisionPerformanceInfo";
// import supervisionPerformanceList from "../view/engineering/supervisionPerformanceList";
//
// import approvalFormList from "../view/engineering/approvalFormList";
// import approvalForm from "../view/engineering/approvalForm";
// import approvalInfo from "../view/engineering/approvalInfo";
// import auditReportList from "../view/engineering/auditReportList";
// import auditReport from "../view/engineering/auditReport";
// import auditReportInfo from "../view/engineering/auditReportInfo";
//
// import costPerformanceList from "../view/engineering/costPerformanceList";
// import costPerformanceForm from "../view/engineering/costPerformanceForm";
// import costPerformanceInfo from "../view/engineering/costPerformanceInfo";
//
// import costContractList from "../view/engineering/costContractList";
// import costContractForm from "../view/engineering/costContractForm";
// import costContractInfo from "../view/engineering/costContractInfo";
//
// import costProjectList from "../view/engineering/costProjectList";
// import costProjectForm from "../view/engineering/costProjectForm";
// import costProjectInfo from "../view/engineering/costProjectInfo";
//
//
// import agencyContractList from "../view/engineering/agencyContractList";
// import agencyContractForm from "../view/engineering/agencyContractForm";
// import agencyContractInfo from "../view/engineering/agencyContractInfo";
// import agencyPerformanceInfo from "../view/engineering/agencyPerformanceInfo";
// import agencyPerformanceList from "../view/engineering/agencyPerformanceList";
// import agencyPerformanceForm from "../view/engineering/agencyPerformanceForm";
//
// import agencyProjectList from "../view/engineering/agencyProjectList";
// import agencyProjectForm from "../view/engineering/agencyProjectForm";
//
//
//
// import companyStatisticsList from "../view/engineering/companyStatisticsList";
// import companyStatisticsEmployee from "../view/engineering/companyStatisticsEmployee";
// import companyStatisticsInfo from "../view/engineering/companyStatisticsInfo";
// import companyValueForm from "../view/engineering/companyValueForm";
// import companyValueInfo from "../view/engineering/companyValueInfo";
// import companyValueList from "../view/engineering/companyValueList";
// import companyQualificationsList from "../view/engineering/companyQualificationsList";
// import companyQualificationsForm from "../view/engineering/companyQualificationsForm";
// import companyQualificationsInfo from "../view/engineering/companyQualificationsInfo";
//
// import companyCreditList from "../view/engineering/companyCreditList";
// import companyCreditForm from "../view/engineering/companyCreditForm";
// import companyCreditInfo from "../view/engineering/companyCreditInfo";
//
// import financeInvoiceForm from "../view/engineering/financeInvoiceForm";
// import financeInvoiceInfo from "../view/engineering/financeInvoiceInfo";
// import financeInvoiceFormList from "../view/engineering/financeInvoiceFormList";
// import financeSettlementFormList from "../view/engineering/financeSettlementFormList";
// import financeSettlementForm from "../view/engineering/financeSettlementForm";
// import financeSettlementItem from "../view/engineering/financeSettlementItem";
// import financeSettlementInfo from "../view/engineering/financeSettlementInfo";
//
// import opProjectList from "../view/engineering/opProjectList";
// import opProjectForm from "../view/engineering/opProjectForm";
// import opProjectInfo from "../view/engineering/opProjectInfo";
//
// import opAccountList from "../view/engineering/opAccountList";
// import opAccountForm from "../view/engineering/opAccountForm";
// import opAccountInfo from "../view/engineering/opAccountInfo";
//
// import opInList from "../view/engineering/opInList";
// import opInForm from "../view/engineering/opInForm";
// import opInInfo from "../view/engineering/opInInfo";
//
// import companyHonorList from "../view/engineering/companyHonorList";
// import companyHonorForm from "../view/engineering/companyHonorForm";
// import companyHonorInfo from "../view/engineering/companyHonorInfo";
//
// import companyMaterialList from "../view/engineering/companyMaterialList";
// import companyMaterialForm from "../view/engineering/companyMaterialForm";
// import companyMaterialInfo from "../view/engineering/companyMaterialInfo";
//
import adForm from "../view/news/adForm";
import adList from "../view/news/adList";
// import newsList from "../view/news/newsList";
import newsForm from "../view/news/newsForm";
import categoryList from "../view/news/categoryList";
// import employeeCertificateList from "../view/engineering/employeeCertificateList";
// import employeeCertificate from "../view/engineering/employeeCertificate";
//
import dicList from '../view/sys/dicList'
//
//
// import dyOrderInfo from "../view/dy/orderInfo";
// import dyOrderList from "../view/dy/orderList";
// import dyUserList from "../view/dy/userList";
// import dyGoodsList from "../view/dy/goodsList";
//
//
// import uploadList from "../view/sys/uploadList";
// import jobList from "../view/oa/jobList";
// import resumeList from "../view/oa/resumeList";
// import cardList from "../view/his/cardList";
//
// import quotationList from "../view/order/quotationList";
//
import orderRefundInfo from '../view/order/orderRefundInfo'
import orderRefundList from '../view/order/orderRefundList'
// import contractList from "../view/engineering/contractList";
import shippingOrderInfo from "../view/order/shippingOrderInfo";
import shippingOrderList from "../view/order/shippingOrderList";
// import posMemberLsList from "../view/pay/posMemberLsList";
// import posMemberLsForm from "../view/pay/posMemberLsForm";
// import posMemberSftList from "../view/pay/posMemberSftList";
// import posForm from "../view/pay/posForm";
//
// import wheel from '../view/ai/wheel'
// import upLoadPayExcel from '../view/pay/finance/upLoadPayExcel'
import demandList from "../view/mall/demandList";
import demandEdit from "../view/mall/demandEdit";
import demandUserRegionList from "../view/mall/demandUserRegionList";
import demandUserKeywordList from "../view/mall/demandUserKeywordList";
import demandCategoryList from "../view/mall/demandCategoryList";
import addressList from "../view/mall/addressList";

import hisProductCategory from "../view/his/productCategory";
import hisProductList from "../view/his/productList";
import hisProductForm from "../view/his/productForm";
import oilProductList from "../view/his/oilProductList";
import serviceOrderList from "../view/his/serviceOrderList";


import newsList from "@/view/news/newsList";

import uploadPayCsv from "@/view/pay/finance/uploadPayCsv";
import changeCsv from "@/view/pay/finance/changeCsv";
import uploadPayExcel from "@/view/pay/finance/uploadPayExcel";
import autoPayList from "@/view/pay/autoPayList";
import orderIcbcList from "@/view/pay/orderIcbcList";
import orderYbList from "@/view/pay/orderYbList";
import orderSftList from "@/view/pay/orderSftList";
import orderLsList from "@/view/pay/orderLsList";
import balanceList from "@/view/pay/finance/balanceList";
import balanceLogList from "@/view/pay/finance/balanceLogList";
import simpleGoodsList from "@/view/mall/simpleGoodsList";
import simpleGoodsForm from "@/view/mall/simpleGoodsForm";
import carStyleList from "@/view/car/carStyleList";
import carPitchList from "@/view/car/carPitchList";
import carList from "@/view/car/carList";
import carForm from "@/view/car/carForm";
import hub from '../view/wheel/hub'
import changeHub from '../view/wheel/changeHub'
import refitHub from '../view/wheel/refitHub'
import hisMemberList from '../view/his/memberList'
import rechargeList from '../view/car/rechargeList'
import withdrawList from '../view/car/withdrawList'
import oilProductSearchList from '../view/his/oilProductSearchList'
import shopBankList from '../view/car/shopBankList'
import shopBalanceSetList from '../view/car/shopBalanceSetList'

import carinfoOwnerLgsList from '../view/car/carinfoOwnerLgsList'
import carinfoOwnerLgsForm from '../view/car/carinfoOwnerLgsForm'
import carLgsList from '../view/car/carLgsList'
import carLgsForm from '../view/car/carLgsForm'

import shopInvoiceList from '../view/shop/shopInvoiceList'
import lgsOilOrderList from '../view/his/lgsOilOrderList'
import carLineList from '../view/car/carLineList'
import withdrawOilList from '../view/car/withdrawOilList'
import boothList from '../view/booth/boothList'
import boothForm from '../view/booth/boothForm'
import expoList from '../view/booth/expoList'


import groupGoodsList from '../view/group/goodsList'
import groupOrderList from '../view/group/orderList'
import groupActivityList from '../view/group/activityList'
import groupTeamList from '../view/group/teamList'
import qrcodePayList from '../view/pay/qrcodePayList'
import jcPayList from '../view/pay/jcPayList'
import jcPayRefundList from '../view/pay/jcPayRefundList'
import jcShopOilOrderList from '../view/pay/jcShopOilOrderList'
Vue.use(Router)
var router = new Router({
  mode: 'history',  //去掉url中的#
  // base: '/',        // 当前线上根目录
    routes: [
      { path: '/login', name: 'Login', component: Login},
      { path: '/hub', name: 'hub', component: hub},
      { path: '/changeHub', name: 'changeHub', component: changeHub},
      { path: '/refitHub', name: 'refitHub', component: refitHub},
     // { path: '/dashboard', name: 'dashboard', component: dashboard},
     // { path: '/PosIndex', name: 'PosIndex', component: PosIndex},
      { path: '/home',name: 'Home', component: Home, redirect: '/welcome',
        children:[
          {
            path: '/jcPayRefundList',name: 'jcPayRefundList',component: jcPayRefundList
          },
          {
            path: '/jcPayList',name: 'jcPayList',component: jcPayList
          },
          {
            path: '/jcShopOilOrderList',name: 'jcShopOilOrderList',component: jcShopOilOrderList
          },
          {
            path: '/qrcodePayList',name: 'qrcodePayList',component: qrcodePayList
          },
          {
            path: '/groupTeamList',name: 'groupTeamList',component: groupTeamList
          },
          {
            path: '/groupActivityList',name: 'groupActivityList',component: groupActivityList
          },
          {
            path: '/groupOrderList',name: 'groupOrderList',component: groupOrderList
          },
          {
            path: '/groupGoodsList',name: 'groupGoodsList',component: groupGoodsList
          },
          {
            path: '/addressList',name: 'addressList',component: addressList
          },
          {
            path: '/rankList',name: 'rankList',component: rankList
          },
          {
            path: '/userRankList',name: 'userRankList',component: userRankList
          },
          {
            path: '/expoList',name: 'expoList',component: expoList
          },
          {
            path: '/boothForm',name: 'boothForm',component: boothForm
          },
          {
            path: '/boothList',name: 'boothList',component: boothList
          },
          {
            path: '/withdrawOilList',name: 'withdrawOilList',component: withdrawOilList
          },
          {
            path: '/carLineList',name: 'carLineList',component: carLineList
          },
          {
            path: '/thirdOilOrderList',name: 'thirdOilOrderList',component: thirdOilOrderList
          },
          {
            path: '/thirdOrderList',name: 'thirdOrderList',component: thirdOrderList
          },
          {
            path: '/thirdWithdrawList',name: 'thirdWithdrawList',component: thirdWithdrawList
          },
          {
            path: '/lgsOilOrderList',name: 'lgsOilOrderList',component: lgsOilOrderList
          },
          {
            path: '/shopInvoiceList',name: 'shopInvoiceList',component: shopInvoiceList
          },
          {
            path: '/carLgsForm',name: 'carLgsForm',component: carLgsForm
          },
          {
            path: '/carLgsList',name: 'carLgsList',component: carLgsList
          },
          {
            path: '/carinfoOwnerLgsForm',name: 'carinfoOwnerLgsForm',component: carinfoOwnerLgsForm
          },
          {
            path: '/shopBalanceSetList',name: 'shopBalanceSetList',component: shopBalanceSetList
          },
          {
            path: '/carinfoOwnerLgsList',name: 'carinfoOwnerLgsList',component: carinfoOwnerLgsList
          },
          {
            path: '/shopBankList',name: 'shopBankList',component: shopBankList
          },
          {
            path: '/oilProductSearchList',name: 'oilProductSearchList',component: oilProductSearchList
          },
          {
            path: '/hisMemberList',name: 'hisMemberList',component: hisMemberList
          },
          {
            path: '/rechargeList',name: 'rechargeList',component: rechargeList
          },
          {
            path: '/withdrawList',name: 'withdrawList',component: withdrawList
          },
          {
            path: '/carForm',name: 'carForm',component: carForm
          },
          {
            path: '/carList',name: 'carList',component: carList
          },
          {
            path: '/carPitchList',name: 'carPitchList',component: carPitchList
          },
          {
            path: '/carStyleList',name: 'carStyleList',component: carStyleList
          },
          {
            path: '/simpleGoodsForm',name: 'simpleGoodsForm',component: simpleGoodsForm
          },
          {
            path: '/simpleGoodsList',name: 'simpleGoodsList',component: simpleGoodsList
          },
          {
            path: '/balanceLogList',name: 'balanceLogList',component: balanceLogList
          },
          {
            path: '/posSourceParamsAuthList',name: 'posSourceParamsAuthList',component: posSourceParamsAuthList
          },
          {
            path: '/balanceList',name: 'balanceList',component: balanceList
          },
          {
            path: '/orderLsList',name: 'orderLsList',component: orderLsList
          },
          {
            path: '/orderSftList',name: 'orderSftList',component: orderSftList
          },
          {
            path: '/orderYbList',name: 'orderYbList',component: orderYbList
          },
          {
            path: '/orderIcbcList',name: 'orderIcbcList',component: orderIcbcList
          },
          {
            path: '/autoPayList',name: 'autoPayList',component: autoPayList
          },
          {
            path: '/uploadPayCsv',name: 'uploadPayCsv',component: uploadPayCsv
          },
          {
            path: '/changeCsv',name: 'changeCsv',component: changeCsv
          },
          {
            path: '/uploadPayExcel',name: 'uploadPayExcel',component: uploadPayExcel
          },
          {
            path: '/newsList',name: 'newsList',component: newsList
          },

          {
            path: '/serviceOrderList',name: 'serviceOrderList',component: serviceOrderList
          },
          {
            path: '/hisProductCategory',name: 'hisProductCategory',component: hisProductCategory
          },
          {
            path: '/hisProductForm',name: 'hisProductForm',component: hisProductForm
          },
          {
            path: '/hisProductList',name: 'hisProductList',component: hisProductList
          },
          {
            path: '/oilProductList',name: 'oilProductList',component: oilProductList
          },
          {
            path: '/demandCategoryList',name: 'demandCategoryList',component: demandCategoryList
          },
          {
            path: '/demandList',name: 'demandList',component: demandList
          },
          {
            path: '/demandEdit',name: 'demandEdit',component: demandEdit
          },
          {
            path: '/demandUserKeywordList',name: 'demandUserKeywordList',component: demandUserKeywordList
          },
          {
            path: '/demandUserRegionList',name: 'demandUserRegionList',component: demandUserRegionList
          },
          {
            path: '/sourcePayList',name: 'sourcePayList',component: sourcePayList
          },
          {
            path: '/posSourceParamsList',name: 'posSourceParamsList',component: posSourceParamsList
          },

          // {
          //   path: '/upLoadPayExcel',name: 'upLoadPayExcel',component: upLoadPayExcel
          // },
          // {
          //   path: '/wheel',name: 'wheel',component: wheel
          // },
          // {
          //   path: '/purchaserForm',name: 'purchaserForm',component: purchaserForm
          // },
          // {
          //   path: '/purchaserList',name: 'purchaserList',component: purchaserList
          // },
          // {
          //   path: '/webMenusList',name: 'webMenusList',component: webMenusList
          // },
          // {
          //   path: '/clueList',name: 'clueList',component: clueList
          // },
          // {
          //   path: '/clueLogList',name: 'clueLogList',component: clueLogList
          // },
          // {
          //   path: '/proxyCashList',name: 'proxyCashList',component: proxyCashList
          // },
          // {
          //   path: '/proxyAccountList',name: 'proxyAccountList',component: proxyAccountList
          // },
          // {
          //   path: '/proxyIcbcList',name: 'proxyIcbcList',component: proxyIcbcList
          // },
          // {
          //   path: '/lsFeeForm',name: 'lsFeeForm',component: lsFeeForm
          // },
          // {
          //   path: '/posForm',name: 'posForm',component: posForm
          // },
          // {
          //   path: '/posMemberLsForm',name: 'posMemberLsForm',component: posMemberLsForm
          // },
          // {
          //   path: '/posMemberLsList',name: 'posMemberLsList',component: posMemberLsList
          // },
          // {
          //   path: '/posMemberSftList',name: 'posMemberSftList',component: posMemberSftList
          // },
          // {
          //   path: '/consultList',name: 'consultList',component: consultList
          // },
          // {
          //   path: '/timetableDetailInfo',name: 'timetableDetailInfo',component: timetableDetailInfo
          // },
          // {
          //   path: '/timetableDetailList',name: 'timetableDetailList',component: timetableDetailList
          // },
          // {
          //   path: '/teacherInfo',name: 'teacherInfo',component: teacherInfo
          // },
          // {
          //   path: '/teacherForm',name: 'teacherForm',component: teacherForm
          // },
          // {
          //   path: '/teacherScheduleList',name: 'teacherScheduleList',component: teacherScheduleList
          // },
          // {
          //   path: '/teacherList',name: 'teacherList',component: teacherList
          // },
          // {
          //   path: '/studentConsumeList',name: 'studentConsumeList',component: studentConsumeList
          // },
          // {
          //   path: '/studentEnrollList',name: 'studentEnrollList',component: studentEnrollList
          // },
          // {
          //   path: '/courseList',name: 'courseList',component: courseList
          // },
          // {
          //   path: '/schoolList',name: 'schoolList',component: schoolList
          // },
          // {
          //   path: '/schoolInfo',name: 'schoolInfo',component: schoolInfo
          // },
          // {
          //   path: '/studentInfo',name: 'studentInfo',component: studentInfo
          // },
          // {
          //   path: '/studentForm',name: 'studentForm',component: studentForm
          // },
          // {
          //   path: '/studentList',name: 'studentList',component: studentList
          // },
          // {
          //   path: '/studentSignList',name: 'studentSignList',component: studentSignList
          // },
          // {
          //   path: '/classesList',name: 'classesList',component: classesList
          // },
          // {
          //   path: '/timeTableList',name: 'timeTableList',component: timeTableList
          // },
          {
            path: '/posMemberTerminalList',name: 'posMemberTerminalList',component: posMemberTerminalList
          },
          {
            path: '/merchantPayList',name: 'merchantPayList',component: merchantPayList
          },
          {
            path: '/merchantPayMoreList',name: 'merchantPayMoreList',component: merchantPayMoreList
          },
          {
            path: '/proxyPosMemberList',name: 'proxyPosMemberList',component: proxyPosMemberList
          },
          {
            path: '/proxyShopList',name: 'proxyShopList',component: proxyShopList
          },
          {
            path: '/proxySourceList',name: 'proxySourceList',component: proxySourceList
          },
          {
            path: '/proxyEmployeeForm',name: 'proxyEmployeeForm',component: proxyEmployeeForm
          },
          {
            path: '/proxyEmployeeInfo',name: 'proxyEmployeeInfo',component: proxyEmployeeInfo
          },
          {
            path: '/proxyRoleList',name: 'proxyRoleList',component: proxyRoleList
          },
          {
            path: '/proxyUserList',name: 'proxyUserList',component: proxyUserList
          },
          {
            path: '/proxyEmployeeList',name: 'proxyEmployeeList',component: proxyEmployeeList
          },
          {
            path: '/proxyModuleList',name: 'proxyModuleList',component: proxyModuleList
          },
          {
            path: '/proxyDepartmentList',name: 'proxyDepartmentList',component: proxyDepartmentList
          },
          {
            path: '/yhcList',name: 'yhcList',component: yhcList
          },
          // {
          //   path: '/shopInfo',name: 'shopInfo',component: shopInfo
          // },
          // {
          //   path: '/proxyInfo',name: 'proxyInfo',component: proxyInfo
          // },
          // {
          //   path: '/proxyForm',name: 'proxyForm',component: proxyForm
          // },
          // {
          //   path: '/proxyGradeList',name: 'proxyGradeList',component: proxyGradeList
          // },
          {
            path: '/proxyList',name: 'proxyList',component: proxyList
          },
          {
            path: '/orderRefundInfo',name: 'orderRefundInfo',component: orderRefundInfo
          },
          {
            path: '/orderRefundList',name: 'orderRefundList',component: orderRefundList
          },
          {
            path: '/shippingOrderList',name: 'shippingOrderList',component: shippingOrderList
          },
          {
            path: '/shippingOrderInfo',name: 'shippingOrderInfo',component: shippingOrderInfo
          },
          // {
          //   path: '/contractList',name: 'contractList',component: contractList
          // },
          // {
          //   path: '/quotationList',name: 'quotationList',component: quotationList
          // },
          // {
          //   path: '/cardList',name: 'cardList',component: cardList
          // },
          {
            path: '/goodsAttributeList',name: 'goodsAttributeList',component: goodsAttributeList
          },
          {
            path: '/goodsTypeList',name: 'goodsTypeList',component: goodsTypeList
          },

          // {
          //   path: '/resumeList',name: 'resumeList',component: resumeList
          // },
          // {
          //   path: '/jobList',name: 'jobList',component: jobList
          // },
          // {
          //   path: '/uploadList',name: 'uploadList',component: uploadList
          // },
          {
            path: '/shopOrderList',name: 'shopOrderList',component: shopOrderList
          },
          {
            path: '/shopOrderInfo',name: 'shopOrderInfo',component: shopOrderInfo
          },
          {
            path: '/orderPrint',name: 'orderPrint',component: orderPrint
          },
          // {
          //   path: '/dyGoodsList',name: 'dyGoodsList',component: dyGoodsList
          // },
          // {
          //   path: '/dyOrderInfo',name: 'dyOrderInfo',component: dyOrderInfo
          // },
          // {
          //   path: '/dyOrderList',name: 'dyOrderList',component: dyOrderList
          // },
          // {
          //   path: '/dyUserList',name: 'dyUserList',component: dyUserList
          // },
          // {
          //   path: '/feeForm',name: 'feeForm',component: feeForm
          // },
          // {
          //   path: '/feeList',name: 'feeList',component: feeList
          // },
          // {
          //   path: '/paymentForm',name: 'paymentForm',component: paymentForm
          // },
          // {
          //   path: '/paymentList',name: 'paymentList',component: paymentList
          // },
          // {
          //   path: '/receiptList',name: 'receiptList',component: receiptList
          // },
          // {
          //   path: '/receiptForm',name: 'receiptForm',component: receiptForm
          // },
          // {
          //   path: '/preApprovalList',name: 'preApprovalList',component: preApprovalList
          // },
          // {
          //   path: '/preApprovalForm',name: 'preApprovalForm',component: preApprovalForm
          // },
          // {
          //   path: '/contractForm',name: 'contractForm',component: contractForm
          // },
          // {
          //   path: '/departmentReportList',name: 'departmentReportList',component: departmentReportList
          // },
          // {
          //   path: '/cashReportList',name: 'cashReportList',component: cashReportList
          // },
          // {
          //   path: '/projectExecutReportList',name: 'projectExecutReportList',component: projectExecutReportList
          // },
          // {
          //   path: '/projectReportList',name: 'projectReportList',component: projectReportList
          // },
          // {
          //   path: '/profitReportList',name: 'profitReportList',component: profitReportList
          // },
          // {
          //   path: '/executeReportList',name: 'executeReportList',component: executeReportList
          // },
          // {
          //   path: '/collectReportList',name: 'collectReportList',component: collectReportList
          // },
          // {
          //   path: '/agreementList',name: 'agreementList',component: agreementList
          // },
          // {
          //   path: '/approvalList',name: 'approvalList',component: approvalList
          // },
          // {
          //   path: '/budgetList',name: 'budgetList',component: budgetList
          // },
          //
          // {
          //   path: '/profitList',name: 'profitList',component: profitList
          // },
          // {
          //   path: '/contractLogList',name: 'contractLogList',component: contractLogList
          // },
          // {
          //   path: '/contractLogForm',name: 'contractLogForm',component: contractLogForm
          // },
          // {
          //   path: '/contractAmountLogList',name: 'contractAmountLogList',component: contractAmountLogList
          // },
          //
          // {
          //   path: '/assetContractList',name: 'assetContractList',component: assetContractList
          // },
          // {
          //   path: '/serviceContractList',name: 'serviceContractList',component: serviceContractList
          // },
          // {
          //   path: '/otherContractList',name: 'otherContractList',component: otherContractList
          // },
          // {
          //   path: '/projectContractList',name: 'projectContractList',component: projectContractList
          // },
          // {
          //   path: '/dailyContractList',name: 'dailyContractList',component: dailyContractList
          // },
          // {
          //   path: '/accountList',name: 'accountList',component: accountList
          // },
          // {
          //   path: '/projectList',name: 'projectList',component: projectList,
          // },
          // {
          //   path: '/projectForm',name: 'projectForm',component: projectForm
          // },
          // {
          //   path: '/feeCategoryList',name: 'feeCategoryList',component: feeCategoryList
          // },
          // {
          //   path: '/hisOrderList',name: 'hisOrderList',component: hisOrderList
          // },
          {
            path: '/oilOrderList',name: 'oilOrderList',component: oilOrderList
          },
          // {
          //   path: '/hisOrderQueueList',name: 'hisOrderQueueList',component: hisOrderQueueList
          // },
          // {
          //   path: '/productForm',name: 'productForm',component: productForm
          // },
          // {
          //   path: '/productCategoryList',name: 'productCategoryList',component: productCategoryList
          // },
          {
            path: '/productList',name: 'productList',component: productList
          },
          // {
          //   path: '/loginLogList',name: 'loginLogList',component: loginLogList
          // },
          // {
          //   path: '/sysLogList',name: 'sysLogList',component: sysLogList
          // },
          // {
          //   path: '/pcFinancePinList',name: 'pcFinancePinList',component: pcFinancePinList
          // },
          // {
          //   path: '/pcFinanceMileList',name: 'pcFinanceMileList',component: pcFinanceMileList
          // },
          // {
          //   path: '/pcFinanceFeeList',name: 'pcFinanceFeeList',component: pcFinanceFeeList
          // },
          // {
          //   path: '/pcFinanceFeeInList',name: 'pcFinanceFeeInList',component: pcFinanceFeeInList
          // },
          // {
          //   path: '/pcFinanceFeeIn',name: 'pcFinanceFeeIn',component: pcFinanceFeeIn
          // },
          // {
          //   path: '/pcFinanceFeeIn',name: 'pcFinanceFeeIn',component: pcFinanceFeeIn
          // },
          {
            path: '/ownerList',name: 'ownerList',component: ownerList
          },

          // {
          //   path: '/employeeCertificateList',name: 'employeeCertificateList',component:employeeCertificateList
          // },
          // {
          //   path: '/employeeCertificate',name: 'employeeCertificate',component:employeeCertificate
          // },
          {
            path: '/adList',name: 'adList',component:adList
          },
          {
            path: '/adForm',name: 'adForm',component:adForm
          },
          // {
          //   path: '/newsList',name: 'newsList',component:newsList
          // },
          {
            path: '/newsForm',name: 'newsForm',component:newsForm
          },
          {
            path: '/categoryList',name: 'categoryList',component:categoryList
          },
          {
            path: '/dicList',name: 'dicList',component: dicList
          },
          // {
          //   path: '/opInList',name: 'opInList',component: opInList
          // },
          // {
          //   path: '/opInForm',name: 'opInForm',component: opInForm
          // },
          // {
          //   path: '/opInInfo',name: 'opInInfo',component: opInInfo
          // },
          //
          // {
          //   path: '/opAccountList',name: 'opAccountList',component: opAccountList
          // },
          // {
          //   path: '/opAccountForm',name: 'opAccountForm',component: opAccountForm
          // },
          // {
          //   path: '/opAccountInfo',name: 'opAccountInfo',component: opAccountInfo
          // },
          //
          // {
          //   path: '/companyHonorList',name: 'companyHonorList',component: companyHonorList
          // },
          // {
          //   path: '/companyHonorForm',name: 'companyHonorForm',component: companyHonorForm
          // },
          // {
          //   path: '/companyHonorInfo',name: 'companyHonorInfo',component: companyHonorInfo
          // },
          // {
          //   path: '/companyMaterialList',name: 'companyMaterialList',component: companyMaterialList
          // },
          // {
          //   path: '/companyMaterialForm',name: 'companyMaterialForm',component: companyMaterialForm
          // },
          // {
          //   path: '/companyMaterialInfo',name: 'companyMaterialInfo',component: companyMaterialInfo
          // },
          // {
          //   path: '/opProjectList',name: 'opProjectList',component: opProjectList
          // },
          // {
          //   path: '/opProjectForm',name: 'opProjectForm',component: opProjectForm
          // },
          // {
          //   path: '/opProjectInfo',name: 'opProjectInfo',component: opProjectInfo
          // },
          // {
          //   path: '/financeSettlementFormList',name: 'financeSettlementFormList',component:financeSettlementFormList
          // },
          // {
          //   path: '/financeSettlementForm',name: 'financeSettlementForm',component:financeSettlementForm
          // },
          // {
          //   path: '/financeSettlementItem',name: 'financeSettlementItem',component:financeSettlementItem
          // },
          // {
          //   path: '/financeSettlementInfo',name: 'financeSettlementInfo',component:financeSettlementInfo
          // },
          // {
          //   path: '/financeInvoiceInfo',name: 'financeInvoiceInfo',component:financeInvoiceInfo
          // },
          // {
          //   path: '/financeInvoiceForm',name: 'financeInvoiceForm',component:financeInvoiceForm
          // },
          // {
          //   path: '/financeInvoiceFormList',name: 'financeInvoiceFormList',component:financeInvoiceFormList
          // },
          // {
          //   path: '/companyCreditForm',name: 'companyCreditForm',component:companyCreditForm
          // },
          // {
          //   path: '/companyCreditInfo',name: 'companyCreditInfo',component:companyCreditInfo
          // },
          // {
          //   path: '/companyCreditList',name: 'companyCreditList',component:companyCreditList
          // },
          //
          // {
          //   path: '/companyQualificationsForm',name: 'companyQualificationsForm',component:companyQualificationsForm
          // },
          // {
          //   path: '/companyQualificationsInfo',name: 'companyQualificationsInfo',component:companyQualificationsInfo
          // },
          // {
          //   path: '/companyQualificationsList',name: 'companyQualificationsList',component:companyQualificationsList
          // },
          // {
          //   path: '/companyValueForm',name: 'companyValueForm',component:companyValueForm
          // },
          // {
          //   path: '/companyValueInfo',name: 'companyValueInfo',component:companyValueInfo
          // },
          // {
          //   path: '/companyValueList',name: 'companyValueList',component:companyValueList
          // },
          // {
          //   path: '/companyStatisticsInfo',name: 'companyStatisticsInfo',component:companyStatisticsInfo
          // },
          // {
          //   path: '/companyStatisticsEmployee',name: 'companyStatisticsEmployee',component:companyStatisticsEmployee
          // },
          // {
          //   path: '/companyStatisticsList',name: 'companyStatisticsList',component:companyStatisticsList
          // },
          // {
          //   path: '/agencyProjectList',name: 'agencyProjectList',component:agencyProjectList
          // }
          // , {
          //   path: '/agencyProjectForm',name: 'agencyProjectForm',component:agencyProjectForm
          // },
          //
          // {
          //   path: '/agencyPerformanceList',name: 'agencyPerformanceList',component:agencyPerformanceList
          // },
          // {
          //   path: '/agencyPerformanceInfo',name: 'agencyPerformanceInfo',component:agencyPerformanceInfo
          // },
          // {
          //   path: '/agencyPerformanceForm',name: 'agencyPerformanceForm',component:agencyPerformanceForm
          // },
          // {
          //   path: '/agencyContractList',name: 'agencyContractList',component:agencyContractList
          // },
          // {
          //   path: '/agencyContractForm',name: 'agencyContractForm',component:agencyContractForm
          // },
          // {
          //   path: '/agencyContractInfo',name: 'agencyContractInfo',component:agencyContractInfo
          // },
          // {
          //   path: '/costPerformanceList',name: 'costPerformanceList',component:costPerformanceList
          // }
          // , {
          //   path: '/costPerformanceForm',name: 'costPerformanceForm',component:costPerformanceForm
          // },
          // {
          //   path: '/costPerformanceInfo',name: 'costPerformanceInfo',component:costPerformanceInfo
          // },
          //
          // {
          //   path: '/costContractList',name: 'costContractList',component:costContractList
          // },
          // {
          //   path: '/costContractForm',name: 'costContractForm',component:costContractForm
          // },
          // {
          //   path: '/costContractInfo',name: 'costContractInfo',component:costContractInfo
          // },
          // {
          //   path: '/costProjectList',name: 'costProjectList',component:costProjectList
          // }
          //
          // , {
          //   path: '/costProjectForm',name: 'costProjectForm',component:costProjectForm
          // },
          // {
          //   path: '/costProjectInfo',name: 'costProjectInfo',component:costProjectInfo
          // },
          //
          // {
          //   path: '/auditReportList',name: 'auditReportList',component:auditReportList
          // },
          // {
          //   path: '/auditReportInfo',name: 'auditReportInfo',component:auditReportInfo
          // },
          // {
          //   path: '/auditReport',name: 'auditReport',component:auditReport
          // },
          // {
          //   path: '/approvalFormList',name: 'approvalFormList',component:approvalFormList
          // },
          // {
          //   path: '/approvalForm',name: 'approvalForm',component:approvalForm
          // },
          // {
          //   path: '/approvalInfo',name: 'approvalInfo',component:approvalInfo
          // },
          //
          // {
          //   path: '/supervisionProjectList',name: 'supervisionProjectList',component:supervisionProjectList
          // }
          // , {
          //   path: '/supervisionProjectForm',name: 'supervisionProjectForm',component:supervisionProjectForm
          // },
          // {
          //   path: '/supervisionPerformanceList',name: 'supervisionPerformanceList',component:supervisionPerformanceList
          // },
          // {
          //   path: '/supervisionPerformanceInfo',name: 'supervisionPerformanceInfo',component:supervisionPerformanceInfo
          // },
          // {
          //   path: '/supervisionContractForm',name: 'supervisionContractForm',component: supervisionContractForm
          // },
          // {
          //   path: '/supervisionContractInfo',name: 'supervisionContractInfo',component: supervisionContractInfo
          // },
          // {
          //   path: '/supervisionContractList',name: 'supervisionContractList',component: supervisionContractList
          // },
          //
          // {
          //   path: '/constructionProjectList',name: 'constructionProjectList',component:constructionProjectList
          // }
          // , {
          //   path: '/constructionProjectForm',name: 'constructionProjectForm',component:constructionProjectForm
          // },
          // {
          //   path: '/constructionPerformanceList',name: 'constructionPerformanceList',component: constructionPerformanceList
          // },
          // {
          //   path: '/constructionPerformanceForm',name: 'constructionPerformanceForm',component: constructionPerformanceForm
          // },
          //
          // {
          //   path: '/supervisionPerformanceForm',name: 'supervisionPerformanceForm',component: supervisionPerformanceForm
          // },
          //
          // {
          //   path: '/constructionPerformanceInfo',name: 'constructionPerformanceInfo',component: constructionPerformanceInfo
          // },
          // {
          //   path: '/constructionContractList',name: 'constructionContractList',component: constructionContractList
          // },
          // {
          //   path: '/constructionContractForm',name: 'constructionContractForm',component: constructionContractForm
          // },
          // {
          //   path: '/constructionContractInfo',name: 'constructionContractInfo',component: constructionContractInfo
          // },
          {
            path: '/shopList',name: 'shopList',component: shopList
          },
          {
            path: '/shopUserList',name: 'shopUserList',component: shopUserList
          },
          {
            path: '/shopModuleList',name: 'shopModuleList',component: shopModuleList
          },
          // {
          //   path: '/shopDepartmentList',name: 'shopDepartmentList',component: shopDepartmentList
          // },
          {
            path: '/shopRoleList',name: 'shopRoleList',component: shopRoleList
          },
          {
            path: '/shopEmployeeList',name: 'shopEmployeeList',component: shopEmployeeList
          },
          // {
          //   path: '/shopEmployeeForm',name: 'shopEmployeeForm',component: shopEmployeeForm
          // },
          {
            path: '/shopForm',name: 'shopForm',component: shopForm
          },
          {
            path: '/goodsCategoryList',name: 'goodsCategoryList',component: goodsCategoryList
          },
          {
            path: '/goodsList',name: 'goodsList',component: goodsList
          },
          {
            path: '/goodsForm',name: 'goodsForm',component: goodsForm
          },
          // {
          //   path: '/orderTreatList',name: 'orderTreatList',component: orderTreatList
          // },
          {
            path: '/userList',name: 'UserList',component: UserList
          },
          // {
          //   path: '/userForm',name: 'userForm',component: userForm
          // },
          // {
          //   path: '/pinList',name: 'PinList',component: PinList
          // },
          // {
          //   path: '/pinReport',name: 'PinReport',component: PinReport
          // },
          // {
          //   path: '/travelList',name: 'TravelList',component: TravelList
          // },
          // {
          //   path: '/travelDetail',name: 'TravelDetail',component: TravelDetail
          // },
          {
            path: '/posMemberList',name: 'posMemberList',component: posMemberList
          },
          // {
          //   path: '/posMemberForm',name: 'posMemberForm',component: posMemberForm
          // },
          // {
          //   path: '/newsCategory',name: 'NewsCategory',component: NewsCategory
          // },
          // {
          //   path: '/moduleList',name: 'ModuleList',component: ModuleList
          // },
          // {
          //   path: '/cmpUserList',name: 'CmpUserList',component: CmpUserList
          // },
          // {
          //   path: '/roleList',name: 'RoleList',component: RoleList
          // },
          // {
          //   path: '/employeeList',name: 'EmployeeList',component: EmployeeList
          // },
          // {
          //   path: '/employeeForm',name: 'employeeForm',component: employeeForm
          // },
          // {
          //   path: '/employeeInfo',name: 'employeeInfo',component: employeeInfo
          // },
          // {
          //   path: '/departmentList',name: 'DepartmentList',component: DepartmentList
          // },
          // {
          //   path: '/ownerList',name: 'ownerList',component: ownerList
          // },
          {
            path: '/welcome',name: 'Welcome',component: Welcome
          },
        ]
      }
    ]
  })


const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}


//挂载路由导航守卫
router.beforeEach((to, from, next) => {
  if(to.path === '/login') return next();
  //获取token
  const tokenStr = window.sessionStorage.getItem('token');
  console.log(tokenStr);
  if(!tokenStr) return next('/login')
  document.title = to.meta.title || '企业数字化管理系统'
  next()
})
export default router


